import Vue from 'vue'
import Vuex from 'vuex'
import Persistor from '../store/persistor.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authenticated: false,
    rtl: true,
  },
  mutations: {
    setAuthenticated(state, auth) {
      state.authenticated = auth;
    },
    setRtl(state, rtl) {
      state.rtl = rtl;
    },
  },
  actions: {
    setAuthTrue({commit}) {
      commit('setAuthenticated', true);
    },
    setAuthFalse({commit}) {
      commit('setAuthenticated', false);
    },
    setRtlTrue({commit}) {
      commit('setRtl', true);
    },
    setRtlFalse({commit}) {
      commit('setRtl', false);
    },
  },
  modules: {},
  plugins: [Persistor]
})
